import { getGroupFilesHubFREStore } from '../store/GroupFilesHubFREStore';
import { mutatorAction } from 'satcheljs';

export const setShouldShowRecentFilesCallout = mutatorAction(
    'setShouldShowRecentFilesCallout',
    async function setShouldShowRecentFilesCallout(shouldShow: boolean) {
        getGroupFilesHubFREStore().shouldShowRecentFilesCallout = shouldShow;
    }
);
